'use strict';

import {ListCtrl} from '../esfasi/listctrl.js';

import {IdentifiedUserModel} from "../../models/identifiedusermodel.js";

export class IdentifiedUsersListCtrl extends ListCtrl
{
	storageNames = {
		query: 'IdentifiedUsersListCtrlQuery'
	};
	
	constructor($scope, $http, $filter, $timeout, $locale, jsDataService){
		super($scope, $http, $filter, $timeout, $locale, jsDataService);
	}
	
	setData(data){
		this.data = [];
		for(let ln of data){
			this.data.push(new IdentifiedUserModel(ln, this.$filter, this.jsDataService));
		}
	}
	
	getColValue(row, col){
		if(typeof(row[col]) === 'undefined'){
			return '';
		}
		if(row instanceof IdentifiedUserModel){
			return row.getValue(col);
		}
		return row[col];
	}
}


